import axiosInstance from "./utils";
import store from "../store";

export default {
  getGroups(clientId) {
    return axiosInstance
      .get(`groups/${clientId}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get groups", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de l'appel des groupes",
        });
      });
  },

  createGroup(clientId, data) {
    return axiosInstance
      .post(`groups/${clientId}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create group", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la création du groupe",
        });
      });
  },

  updateGroup(clientId, data) {
    return axiosInstance
      .put(`groups/${clientId}/${data.id}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update group", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la modification du groupe",
        });
      });
  },

  deleteGroup(clientId, data) {
    return axiosInstance
      .delete(`groups/${clientId}/${data.id}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on delete group", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la suppression du groupe",
        });
      });
  },
};
